import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f738a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-[1.5rem]"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "info-title" }, "Informations du produit parent", -1))
const _hoisted_3 = { class: "info-row" }
const _hoisted_4 = { class: "info-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold-text" }, "Prototype :", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold-text" }, "Fournisseur :", -1))
const _hoisted_7 = { class: "info-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold-text" }, "Nom du produit :", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold-text" }, "Nom du produit dans l’admin :", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "Déclinaisons du produit", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "column" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 mt-8" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold !text-blue-800" }, "Récapitulatif des déclinaisons générées")
], -1))
const _hoisted_15 = { class: "min-w-full mt-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-medium border-b border-gray-200 bg-gray-50" }, " Attributs "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-medium border-b border-gray-200 bg-gray-50" }, " Valeurs des attributs "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-medium border-b border-gray-200 bg-gray-50" }, " Supprimer cette combinaison "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-medium border-b border-gray-200 bg-gray-50" })
  ])
], -1))
const _hoisted_17 = { class: "bg-white" }
const _hoisted_18 = { class: "text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_19 = { class: "text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_20 = { class: "text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_21 = { class: "text-center px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "flex justify-center items-center mt-4" }

import { ref, onMounted, watch } from "vue";
import ApiService from "@/_services/api.service";
import Button from "primevue/button";
import swal from "@/_helpers/swal";
import { useRoute } from 'vue-router';
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomAttribut',
  setup(__props) {

let masterProduct = ref(null);
let attributes = ref([]);
let allAttributesOptions = ref([]);
let attributeValuesOptions:any  = ref([]);
let mappingAttributes =ref([]);
let mappingValues = ref([]);
let combinationValues: any = ref([]);
const route = useRoute();
const uuid = ref(route.params.uuid);
let minNbrAttributes = ref(1);
let maxNbrAttributes = ref(5);
const goBack = () => {
  router.push({ name: 'ListProducts' });
};
function filterAttributesOptions(index) {
  let optionsSelected = attributes.value.map((val: any) => {
    return val.attribute;
  })
  return allAttributesOptions.value.filter((option: any) => {
      return optionsSelected.indexOf(option.value) === -1 || optionsSelected.indexOf(option.value) === index
    }
  )
}
async function fetchValuesData(index) {
  const  uuid = attributes.value[index].attribute;
  attributes.value[index].attributeValue = [];
  try {
    const response =  await ApiService.get(`attributes/${uuid}`);
    attributeValuesOptions.value[index] = response.data.data.attributeValues.map(
      (val: any) => {
        mappingValues.value[val.uuid] = val.name ;
        return {
          label: val.name,
          value: val.uuid
        }
      }
    );
  } catch (error) {
    console.error(error);
  }


}
async function fetchAttributes() {
  try {
    const response = await ApiService.get('attributes?itemsPerPage=1000');
    allAttributesOptions.value = response.data.data.map((attr: any) => {
      mappingAttributes.value[attr.uuid] = attr.name
      return { label: attr.name, value: attr.uuid }});

  } catch (error) {
    console.log(error);
  }
}
async function fetchMasterProduct() {
  try {
    const response = await ApiService.get(`master-product/${uuid.value}`);
    masterProduct.value = response.data.data;
    initAttributesData();
  } catch (error) {
    console.error('Error fetching master product:', error);
  }
}

onMounted(() => {
    fetchMasterProduct()
});


function initAttributesData() {
    if (masterProduct?.value?.attributes?.length) {
        maxNbrAttributes = minNbrAttributes = masterProduct?.value?.attributes?.length;
        allAttributesOptions.value = masterProduct.value.attributes.map((attr: any, index: any) => {
            mappingAttributes.value[attr.uuid] = attr.name
            attributes.value[index] = {attribute: attr.uuid, values: []};
            fetchValuesData(index);
            return {label: attr.name, value: attr.uuid}
        });
    } else {
        fetchAttributes();
    }
}

function checkCombinationAffectedToVariant(combination) {
    let valuesUuidsForCombination = combination.map((val: any) => {
        return val.value;
    });
    let attributesValuesForVariants = Object.values(masterProduct?.value?.attributesValues);
    for (const valuesUuidForVariant of attributesValuesForVariants) {
        let exist = valuesUuidForVariant.every(value => valuesUuidsForCombination.includes(value));
        if (exist) {
            return true;
        }
    }
    return false;
}

function submitHandler(data, formNode) {
  let apiData = {
    variantsAttributes: [],
    masterProduct: uuid.value,
  }
  for (const combination of combinationValues.value) {
      if (checkCombinationAffectedToVariant(combination)) {
          continue;
      }
    let variantsAttributes = [];
    for (const attr of combination) {
      let value = attr.value;
      let attributeUuid = attr.attribute;
      variantsAttributes.push({
        attributeUuid: attributeUuid,
        attributeValueUuid: mappingValues.value[value] ? value : '',
        value: mappingValues.value[value] ? mappingValues.value[value] : value
      })
    }
    apiData.variantsAttributes.push({attributes: variantsAttributes})
  }

    if (apiData.variantsAttributes.length == 0) {
        swal.error('Veuillez choisir d’autres déclinaisons.’');
        return;
    }
  return ApiService.post("/multiple-variant-product", apiData)
    .then(({data}) => {
      swal.success("", "Les déclinaisons ont été créées !");
      router.push({
        name: "listProductVariants",
        params: {
          uuid: uuid.value,
        },
      })
    })
    .catch(({response}) => {
      console.log(response)
    });

}


function generateCombinations(): void {

  combinationValues.value = [];
  let attributesValuesData = [];
  for (const element of attributes.value) {
    let data = [];
    if (element.attributeValue) {
      for (const value of element.attributeValue) {
        data.push({attribute: element.attribute, value: value})
      }
    }

    attributesValuesData.push(data);
  }

  const result: any[][] = [[]];

  for (const subArray of attributesValuesData) {
    const newCombinations: any[][] = [];

    for (const combination of result) {
      for (const element of subArray) {
        newCombinations.push([...combination, element]);
      }
    }

    result.length = 0;
    result.push(...newCombinations);
  }
  combinationValues.value = result;
}



watch(
  attributes,
  (value) => {
    generateCombinations();

  })



return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormKit, {
      type: "submit",
      label: "Retour",
      onClick: goBack,
      "prefix-icon": "left",
      style: { 
      borderColor: '#0275ff',
      borderWidth: '1px',
      borderStyle: 'solid',
      color: '#0275ff',
      backgroundColor: 'white',
      transition: 'background-color 0.3s, color 0.3s',
    },
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => {$event.target.style.backgroundColor = '#0275ff'; $event.target.style.color = 'white'}),
      onMouseout: _cache[1] || (_cache[1] = ($event: any) => {$event.target.style.backgroundColor = 'white'; $event.target.style.color = '#0275ff'})
    }),
    (_unref(masterProduct))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_unref(masterProduct).prototype.value), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_unref(masterProduct).supplier.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_unref(masterProduct).properties.productName[0].value), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_unref(masterProduct).properties.adminProductName[0].value), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_10,
    _createVNode(_component_FormKit, {
      type: "form",
      onSubmit: submitHandler,
      value: true,
      actions: false,
      "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
    }, {
      default: _withCtx(({ value }) => [
        _createVNode(_component_FormKit, {
          id: "repeater",
          name: "values",
          type: "repeater",
          label: "Création de déclinaisons",
          "add-label": "Ajouter un attribut",
          min: _unref(minNbrAttributes),
          max: _unref(maxNbrAttributes),
          modelValue: _unref(attributes),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(attributes) ? (attributes).value = $event : attributes = $event)),
          onChange: generateCombinations
        }, {
          default: _withCtx(({ index }) => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_FormKit, {
                  type: "select",
                  label: "Attribut",
                  name: "attribute",
                  validation: "required|length:1,50",
                  placeholder: "Sélectionner une valeur",
                  "validation-messages": {
              required: 'Ce champ est obligatoire.',
              length: 'Ce champ doit contenir maximum 50 caractères.',
            },
                  options: filterAttributesOptions(index),
                  onChange: ($event: any) => (fetchValuesData(index))
                }, null, 8, ["validation-messages", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_unref(attributeValuesOptions)[index])
                  ? (_openBlock(), _createBlock(_component_FormKit, {
                      key: 0,
                      type: "taglist",
                      label: "Valeur",
                      name: "attributeValue",
                      validation: "required|length:1,50",
                      placeholder: "Sélectionner une valeur",
                      "validation-messages": {
              required: 'Ce champ est obligatoire.',
              length: 'Ce champ doit contenir maximum 50 caractères.',
            },
                      options: _unref(attributeValuesOptions)[index].length ? _unref(attributeValuesOptions)[index]:[''],
                      "allow-new-values": true
                    }, null, 8, ["validation-messages", "options"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["min", "max", "modelValue"]),
        _hoisted_14,
        _createElementVNode("table", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("tbody", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(combinationValues), (combination, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combination, (attr, indexAttr) => {
                      return (_openBlock(), _createElementBlock("li", { key: indexAttr }, _toDisplayString(_unref(mappingAttributes)[attr.attribute]), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(combination, (attr, indexVal) => {
                      return (_openBlock(), _createElementBlock("li", { key: indexVal }, _toDisplayString(_unref(mappingValues)[attr.value] ? _unref(mappingValues)[attr.value]: attr.value), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_20, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-trash",
                    class: "p-button-danger",
                    title: "supprimer",
                    onClick: ($event: any) => (_unref(combinationValues).splice(index,1))
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("td", _hoisted_21, [
                  (checkCombinationAffectedToVariant(combination))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Cette déclinaison existe déjà."))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_FormKit, {
            type: "submit",
            label: "Créer les déclinaisons",
            class: "btn"
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})